import Notice from './Notice.vue'

const NoticePlugin = {
	install(Vue) {
		const CONSTRUCTOR = Vue.extend(Notice)
		const CACHE = {}

		function notice(msg, action = () => ({}), options = {}) {
			options.id = options.id || (new Date()).getTime()
			const notice = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR())
			options.message = msg
			options.action = action

			if (!notice.$el) {
				const vm = notice.$mount()
				document.querySelector(options.parent || 'body').appendChild(vm.$el)
			}
			notice.queued.push(options)
		}

		Vue.notice = Vue.prototype.$notice = notice
	},
}

export default NoticePlugin
